import { type NextRequest } from 'next/server'
import { handlers } from '@/auth'
import { checkRateLimit, extractIp } from '@/lib/rate-limiter'

export const GET = handlers.GET

// Limits: 5 magic link sends per email per 15 min, 10 per IP per 15 min
const MAGIC_LINK_PER_EMAIL = { limit: 5, windowSeconds: 15 * 60 }
const MAGIC_LINK_PER_IP = { limit: 10, windowSeconds: 15 * 60 }

export async function POST(
  req: NextRequest,
  ctx: { params: Promise<{ nextauth: string[] }> },
) {
  const { nextauth } = await ctx.params

  if (nextauth.join('/') === 'signin/nodemailer') {
    let email: string | null = null

    try {
      const formData = await req.clone().formData()
      email = (formData.get('email') as string | null)?.trim().toLowerCase() ?? null
    } catch {
      // body wasn't form-encoded; IP-only limiting still applies
    }

    const ip = extractIp(req)

    const ipResult = await checkRateLimit(
      `magic:ip:${ip}`,
      MAGIC_LINK_PER_IP.limit,
      MAGIC_LINK_PER_IP.windowSeconds,
    )
    if (!ipResult.success) {
      return new Response(
        JSON.stringify({ error: 'Too many requests. Please try again later.' }),
        {
          status: 429,
          headers: {
            'Content-Type': 'application/json',
            'Retry-After': String(Math.ceil((ipResult.reset - Date.now()) / 1000)),
          },
        },
      )
    }

    if (email) {
      const emailResult = await checkRateLimit(
        `magic:email:${email}`,
        MAGIC_LINK_PER_EMAIL.limit,
        MAGIC_LINK_PER_EMAIL.windowSeconds,
      )
      if (!emailResult.success) {
        return new Response(
          JSON.stringify({ error: 'Too many sign-in requests for this email. Please try again later.' }),
          {
            status: 429,
            headers: {
              'Content-Type': 'application/json',
              'Retry-After': String(Math.ceil((emailResult.reset - Date.now()) / 1000)),
            },
          },
        )
      }
    }
  }

  return handlers.POST(req)
}
